export default __webpack_public_path__ + "static/media/arrowImg.4a9aca72.svg";